<p-dialog styleClass="custom-modal" [visible]="visible" (visibleChange)="onChange($event)" [modal]="true"
    [showHeader]="true" [closeOnEscape]="false" [header]="header" [closable]="true" (onHide)="onHideClicked($event)" (onShow)="onShowClicked($event)">
    <ng-content></ng-content>
</p-dialog>
